import {TipoAlergiaEnum} from '../service-proxies/service-proxies'

export class TipoAlergiaValues{
    public static Alimentar = TipoAlergiaEnum._0
    public static Respiratoria = TipoAlergiaEnum._1
    public static Pele = TipoAlergiaEnum._2
    public static Medicamentos = TipoAlergiaEnum._3
    public static PicadaInsetos = TipoAlergiaEnum._4
    public static Outros = TipoAlergiaEnum._5
}

export class TipoAlergiaEnumItem {
    constructor(public name: string, public type: TipoAlergiaEnum) { }
}

export class TipoAlergiaList {
    TiposAlergia: TipoAlergiaEnumItem[] = [
        new TipoAlergiaEnumItem('Alergia Alimentar', TipoAlergiaEnum._0),
        new TipoAlergiaEnumItem('Alergia Respiratória', TipoAlergiaEnum._1),
        new TipoAlergiaEnumItem('Alergia de Pele', TipoAlergiaEnum._2),
        new TipoAlergiaEnumItem('Alergia a Medicamentos', TipoAlergiaEnum._3),
        new TipoAlergiaEnumItem('Alergia a Picadas de Insetos', TipoAlergiaEnum._4),
        new TipoAlergiaEnumItem('Outros', TipoAlergiaEnum._5),
    ];

    getNomeGrafico(tipo: TipoAlergiaEnum): string {
        const item = this.TiposAlergia.find(x => x.type === tipo);
        return item ? item.name : 'Nome não encontrado';
    }
}